import { NgModule } from "@angular/core";

import { DialogModule } from "@intocare/shared/ui-design-system";

import { SaveOnExit } from "./guards/save-on-exit.guard";

@NgModule({
	imports: [DialogModule],
	providers: [SaveOnExit],
})
export class SaveOnExitModule {}
